import { transport } from 'config/transport';

export function callApiSaveThuChiDauNamMamNon(congDoanId, academicYear, body) {
    return transport.post(`/congdoan/${congDoanId}/thuchi/thudaunam/academicYear/${academicYear}`, body);
}
